<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">{{ $t("message.chatbotFeature") }}</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.chatbotButtonActivity">{{ $t("message.chatbotButtonActivity") }}</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-label">{{ $t("message.maxSessionCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.maxSessionCount" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("message.storyCountLimit") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.storyCountLimit" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("message.integrationCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.integrationCount" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("message.versionHistoryCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.versionHistoryCount" />
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-label">{{ $t("message.activeChatbotLimit") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.activeChatbotLimit" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            maxSessionCount: 0,
            storyCountLimit: 0,
            integrationCount: 0,
            versionHistoryCount: 0,
            activeChatbotLimit: 0,
            chatbotButtonActivity: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.CHATBOT);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.CHATBOT, ...this.featureForm };
                response[Features.CHATBOT.MAX_SESSION_COUNT] = +v.maxSessionCount || 0;
                response[Features.CHATBOT.STORY_COUNT_LIMIT] = +v.storyCountLimit || 0;
                response[Features.CHATBOT.INTEGRATION_COUNT] = +v.integrationCount || 0;
                response[Features.CHATBOT.VERSION_HISTORY_COUNT] = +v.versionHistoryCount || 0;
                response[Features.CHATBOT.ACTIVE_CHATBOT_LIMIT] = +v.activeChatbotLimit || 0;
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.CHATBOT);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
